import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { AvanoMenuComponent } from './avano-menu.component';
import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';

@NgModule({
  imports: [CommonModule, RouterModule, TranslateModule.forChild({ extend: true })],
  exports: [AvanoMenuComponent],
  declarations: [AvanoMenuComponent]
})
export class AvanoMenuModule {}
